export default "__VITE_ASSET__Bpfhgv9D__"